import React, { useEffect, useState } from "react";
import store from "../../store/store";
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago/commonjs/ReactTimeAgo";
import {
  getNotifications,
  getPendingApproval,
  updateNotification,
} from "../../services/usersService";
import ContentLayout from "../content/ContentLayout";
import IllustrationIcon from "../content/IllustrationIcon";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../content/BootstrapTooltip";
import DialogLayout from "../content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import ApprovalAction from "../../pages/home/users/approval/approvalAction";
import TaskDetail from "../../pages/home/users/tasks/taskDetail";

function Notifications({ history }) {
  const [notifications, setNotifications] = useState([]);
  const { auth } = store.getState();
  const userID = auth.user.userID;
  const { socket, setTotalNotification, reload } = useGlobalData();
  const [selectedPendingApproval, setSelectedPendingApproval] = useState({
    docID: 0,
    appCode: "",
  });
  const [openApprovalAction, setOpenApprovalAction] = useState(false);
  const [openTaskDetail, setOpenTaskDetail] = useState(false);
  const [taskID, setTaskID] = useState(0);

  useEffect(() => {
    socket.on(`push-notifications:${userID}`, (message) => {
      getNotificationsData();
    });

    getNotificationsData();

    return () => {
      socket.off(`push-notifications:${userID}`);
    };
  }, [userID, reload]);

  return (
    <React.Fragment>
      {notifications && notifications.length > 0 ? (
        <React.Fragment>
          {notifications.map((notification, index) => (
            <React.Fragment key={index}>
              <div
                className={`kt-notification-v2__item`}
                onClick={() => {
                  if (notification.notificationTypeID === 1) {
                    if (notification.toUsers[0].statusID === 1) {
                      updateNotification(notification).then((response) => {
                        getNotificationsData();
                      });
                    }
                    history.push("/users/messages/" + notification.objectID);
                  } else if (notification.notificationTypeID === 2) {
                    if (notification.objectID > 0) {
                      getPendingApprovalData(notification.objectID);
                    }
                  } else if (notification.notificationTypeID === 3) {
                    if (notification.objectID > 0) {
                      if (notification.toUsers[0].statusID === 1) {
                        updateNotification(notification).then((response) => {
                          getNotificationsData();
                        });
                      }
                      getTaskData(notification.objectID);
                      history.push("/users/tasks");
                    }
                  }
                }}
              >
                <React.Fragment>
                  <BootstrapTooltip
                    title={`${
                      notification.notificationTypeID === 1
                        ? "Message Notification"
                        : notification.notificationTypeID === 2
                        ? "Approval Request Notification"
                        : notification.notificationTypeID === 3
                        ? "Task Notification"
                        : null
                    }`}
                  >
                    <div className="kt-notification-v2__item-icon">
                      {notification.notificationTypeID === 1 ? (
                        <i className={`fas fa-mail-bulk kt-font-success`} />
                      ) : notification.notificationTypeID === 2 ? (
                        <i className={`fas fa-diagnoses kt-font-primary`} />
                      ) : notification.notificationTypeID === 3 ? (
                        <i className={`fas fa-tasks kt-font-info`} />
                      ) : null}
                    </div>
                  </BootstrapTooltip>
                  <div className="kt-notification-v2__item-wrapper">
                    <div className={`kt-notification-v2__item-title`}>
                      {notification.message}
                    </div>
                    <div className={`kt-notification-v2__item-subject`}>
                      {notification.subject}
                    </div>
                    <div className={`kt-notification-v2__item-desc`}>
                      <ReactTimeAgo
                        date={new Date(notification.CreatedAt)}
                        locale="en-US"
                      />
                    </div>
                  </div>
                </React.Fragment>
              </div>
            </React.Fragment>
          ))}
        </React.Fragment>
      ) : (
        <ContentLayout>
          <IllustrationIcon
            icon="fas fa-bell-slash"
            color="danger"
            description="There are no notifications yet!"
            guidance="You will receive your first notification soon :)"
          />
        </ContentLayout>
      )}
      <DialogLayout
        open={openApprovalAction}
        title="Process Approval"
        onCloseDialog={() => {
          setOpenApprovalAction(false);
        }}
        minHeight={true}
      >
        <ApprovalAction
          approvalProcess={selectedPendingApproval}
          onConfirmSave={() => {
            getNotificationsData();
            setOpenApprovalAction(false);
          }}
          onCloseDialog={() => {
            setOpenApprovalAction(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openTaskDetail}
        title="Task Detail"
        onCloseDialog={() => {
          setOpenTaskDetail(false);
        }}
      >
        <TaskDetail
          taskID={taskID}
          onCloseDialog={() => {
            setOpenTaskDetail(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenTaskDetail(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getNotificationsData() {
    const response = await getNotifications();
    const { data } = response.data;
    setNotifications(data.notifications);
    setTotalNotification(data.notifications.length);
  }

  async function getPendingApprovalData(approvalProcessID = 0) {
    const response = await getPendingApproval(approvalProcessID);
    const { data } = response.data;
    setSelectedPendingApproval(data.approvalProcess);
    setOpenApprovalAction(true);
  }

  async function getTaskData(taskID = 0) {
    setTaskID(taskID);
    setOpenTaskDetail(true);
  }
}

export default Notifications;
